<template>
  <div class="pain-points-page flex-col">
    <div class="pain-points-backdrop flex-col">
      <div class="pain-points-audience-list flex-col">
        <div class="pain-points-audience-card flex-col" v-for="(item, index) in audiencePainPoints" :key="index">
          <div class="pain-points-audience-card__header flex-col" :style="{ background: item.headerBackground }">
            <span class="pain-points-audience-card__audience-name" v-html="item.audienceName"></span>
          </div>
          <div class="pain-points-audience-card__customer-acquisition-challenge flex-col"><span class="pain-points-audience-card__customer-acquisition-copy" v-html="item.customerAcquisitionChallenge"></span></div>
          <div class="pain-points-audience-card__resource-access-challenge flex-col"><span class="pain-points-audience-card__resource-access-copy" v-html="item.resourceAccessChallenge"></span></div>
          <div class="pain-points-audience-card__product-support-challenge flex-col"><span class="pain-points-audience-card__product-support-copy" v-html="item.productSupportChallenge"></span></div>
          <div class="pain-points-audience-card__brand-pricing-challenge flex-col"><span class="pain-points-audience-card__brand-pricing-copy" v-html="item.brandPricingChallenge"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PartnershipPainPointsView',
  data() {
    return {
      audiencePainPoints: [
        {
          headerBackground: `url(${require('@/assets/pages/partnership-pain-points/images/remote/a5c915b760ade0aff669734987e13d95.png')}) 100% no-repeat`,
          audienceName: '个人填报师',
          customerAcquisitionChallenge: '不懂得获客拓展，只能靠熟人介绍',
          resourceAccessChallenge: '缺乏高校资源，了解最新动态学习成本高',
          productSupportChallenge: '无产品支撑，只能收咨询费',
          brandPricingChallenge: '缺乏品牌背书，收费低不敢涨价'
        },
        {
          headerBackground: `url(${require('@/assets/pages/partnership-pain-points/images/remote/0ee85959607ea6e69d5145f57b2873dd.png')}) 100% no-repeat`,
          audienceName: '教育机构',
          customerAcquisitionChallenge: '学生毕业后就流失，多年经营的口碑付之东流',
          resourceAccessChallenge: '产品单一，只能补课盈利，模式受限',
          productSupportChallenge: '想升级转型学涯服务，但不知从何入手',
          brandPricingChallenge: '差异化不足，只能打价格战'
        }
      ]
    };
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/partnership-pain-points/styles/index.response.css" />
